import { render, staticRenderFns } from "./TenantDialog.vue?vue&type=template&id=2f650474"
import script from "./TenantDialog.vue?vue&type=script&lang=js"
export * from "./TenantDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports